import { HTMLProps, useContext } from 'react';
import { SELECTED_FUND_COLORS } from '../../../../config/constants';
import { FundsSelectionContext } from '../../../../contexts/funds-robot/FundsSelectionContext';
import { ComparisonScreenFundSelectionContext } from '../ComparisonScreen';

export const StickyPageSelector: React.FC<{} & HTMLProps<HTMLDivElement>> = ({ className, ...rest }) => {
    const fundsContext = useContext(FundsSelectionContext);
    const comparisonContext = useContext(ComparisonScreenFundSelectionContext);
    return comparisonContext.selectedFund ? (
        <div
            className={`lg:hidden sticky bottom-0 left-0 flex flex-col shadow-lg bg-gray-50 border-t border-gray-200 p-1 ${className}`}
            {...rest}
        >
            <div className="flex justify-center text-center pt-2 pb-2">{comparisonContext.selectedFund.name}</div>
            <div className="flex flex-1 justify-around flex-row pb-4 pt-1">
                {SELECTED_FUND_COLORS.map((color, index) => {
                    return index < fundsContext.funds.selected.length ? (
                        <button
                            className={`flex justify-center items-center focus:outline-hidden rounded-full transition ${
                                comparisonContext.selectedFundIndex === index
                                    ? `ring-4 ring-offset-2 ring-opacity-40 ring-offset-gray-50  ${
                                          index === 0
                                              ? 'ring-bnd-yellow'
                                              : index === 1
                                              ? 'ring-bnd-blue'
                                              : 'ring-bnd-pink'
                                      }`
                                    : 'opacity-40'
                            }`}
                            onClick={() => {
                                comparisonContext.setSelectedFund(fundsContext.funds.selected[index]);
                            }}
                            key={index}
                        >
                            <div className={`w-6 h-6 rounded-full`} style={{ background: color }}></div>
                        </button>
                    ) : null;
                })}
            </div>
        </div>
    ) : null;
};
